<template>
  <div
    class="select-box-group"
    v-bind:style="{
      display: displayBetweenSelectBox ? `inline-flex` : 'block',
    }"
    v-bind:class="displayBetweenSelectBox ? `select-box-multi-line` : ''"
  >
    <div class="select-from">
      <DxNumberBox
        id="custom-templates"
        :on-value-changed="onNumberValueChanged"
        :showClearButton="true"
        @initialized="initialized"
        ref="select-from-value"
        :validationMessageMode="validationMessageMode"
        :value="fromValue"
        :readOnly="setReadOnly"
        @enter-key="onPressEnterKey"
        :placeholder="'Enter ' + label"
      >
        <DxNumberBoxButton
          :options="searchTypes"
          name="search"
          location="before"
        />

        <template #select-from-clear>
          <div>
            <span class="dx-clear-button-area" @click="clearSelectFrom"
              ><span class="dx-icon dx-icon-clear"></span
            ></span>
          </div>
        </template>

        <template #show-drop-down>
          <div>
            <DxDropDownButton
              class="search-option"
              :showArrowIcon="false"
              :stylingMode="'text'"
              :items="filterDateRangeOptions()"
              keyExpr="value"
              displayExpr="text"
              :drop-down-options="{ width: 250 }"
              :onItemClick="searchOptionItemClick.bind(this)"
              :useSelectMode="true"
              :value="selectToValue"
              :selectedItemKey="selectedOperator"
              width="25"
            >
            </DxDropDownButton>
          </div>
        </template>
      </DxNumberBox>
    </div>

    <div class="select-to" v-if="displayBetweenSelectBox">
      <span>To</span>
      <DxNumberBox
        id="custom-templates"
        :on-value-changed="onToSelectionChanged"
        :searchEnabled="true"
        :showClearButton="showClearButton"
        ref="select-to-value"
        :validationMessageMode="validationMessageMode"
        :value="toValue"
        :readOnly="setReadOnly"
        @enter-key="onPressEnterKey"
        :placeholder="'Enter ' + label"
      >
      </DxNumberBox>
    </div>
  </div>
</template>
<script>
import {
  DxNumberBox,
  DxButton as DxNumberBoxButton,
} from "devextreme-vue/number-box";
import { GridReportService } from "../_services/api/reports/grid-report.service";

export default {
  components: {
    DxNumberBox,
    DxNumberBoxButton,
  },
  props: {
    valueChangeCallBack: {
      type: Function,
      default: () => function () {},
    },
    onValueChanged: {
      type: Function,
      default: () => function () {},
    },
    numberBoxOptions: {
      type: [Object, Array],
      default: () => {},
    },
    gridData: {
      type: Object,
      default: () => {},
    },
    showClearButton: {
      type: Boolean,
      default: true,
    },
    setReadOnly: {
      type: Boolean,
      default: false,
    },
    dataModel: {
      type: Object,
      default: () => {},
    },
    onPressEnterKey: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      searchTypes: {
        template: "show-drop-down",
        elementAttr: { class: "search-option-drop-down" },
        visible: true,
      },
      searchOptionItems: [
        { icon: "equal", text: "Equals", value: "=" },
        { icon: "less", text: "Less than", value: "<" },
        { icon: "greater", text: "Greater than", value: ">" },
        { icon: "lessorequal", text: "Less than or equal to", value: "<=" },
        {
          icon: "greaterorequal",
          text: "Greater than or equal to",
          value: ">=",
        },
        { icon: "range", text: "Between", value: "between" },
      ],
      selectToValue: undefined,
      selectedOperator: undefined,
      displayBetweenSelectBox: false,
      dataField: this.numberBoxOptions[0].dataField,
      defaultValue: this.numberBoxOptions[0].defaultValue
        ? this.numberBoxOptions[0].defaultValue
        : undefined,
      validationMessageMode: this.numberBoxOptions[0].validationMessageMode
        ? this.numberBoxOptions[0].validationMessageMode
        : "auto",
      readOnly: this.numberBoxOptions[0].readOnly || this.setReadOnly,
      fieldTemplate: this.numberBoxOptions[0].fieldTemplate
        ? "field-template"
        : null,
      toValue: undefined,
      fromValue: undefined,
      label: this.numberBoxOptions[0].label,
    };
  },
  mounted() {
    this.selectedOperator = "=";
    if (this.defaultValue && this.defaultValue.length != 0) {
      if (
        Object.keys(this.numberBoxOptions[0].defaultValue).length > 0 &&
        this.numberBoxOptions[0].filterOperator == "between" &&
        !this.dataModel.filterOperator
      ) {
        this.fromValue = this.numberBoxOptions[0].defaultValue.from;
        this.toValue = this.numberBoxOptions[0].defaultValue.to;
        this.selectedOperator = "between";
        this.displayBetweenSelectBox = true;
      } else {
        if (this.dataModel.filterOperator == "between") {
          this.fromValue = this.dataModel.fromValue;
          this.toValue = this.dataModel.toValue;
          this.selectedOperator = "between";
          this.displayBetweenSelectBox = true;
        }
        if (this.dataModel.fromValue) {
          this.defaultValue = [this.dataModel.fromValue];
        } else {
          this.onNumberValueChanged({ value: this.defaultValue[0] });
        }
      }

      if (this.numberBoxOptions[0].filterOperator) {
        this.selectedOperator = this.dataModel.filterOperator =
          this.numberBoxOptions[0].filterOperator;
      }

      if (this.dataModel.filterOperator) {
        this.selectedOperator = this.dataModel.filterOperator;
      }
    } else {
      if (this.dataModel.fromValue)
        this.defaultValue = this.dataModel.fromValue;
    }
  },
  methods: {
    clearSelectFrom() {
      this.fromValue = undefined;

      var datebox = this.$refs["select-from-value"].instance;
      datebox.reset();
    },
    searchOptionItemClick(e) {
      if (this.$refs["select-to-value"]) {
        this.toValue = undefined;
        var datebox = this.$refs["select-to-value"].instance;
        datebox.reset();
      }

      this.selectedOperator = e.itemData.value;
      this.dataModel["filterOperator"] = e.itemData.value;

      if (e.itemData.value == "between") this.displayBetweenSelectBox = true;
      else this.displayBetweenSelectBox = false;

      if (this.fromValue) {
        this.onNumberValueChanged({ value: this.fromValue });
      }
    },
    filterDateRangeOptions() {
      return this.searchOptionItems;
    },
    onNumberValueChanged(e) {
      this.fromValue = e.value;
      this.dataModel["fromValue"] = e.value;
      this.setFilterArray(e);
    },
    onToSelectionChanged(e) {
      this.toValue = e.value;
      this.dataModel["toValue"] = e.value;
      this.setFilterArray(e);
    },
    setFilterArray(e) {
      let filter = [];
      var setFilter = [];

      if (this.selectedOperator != "between" && e.value) {
        setFilter = [];
        setFilter[0] = this.numberBoxOptions[0].dataField;
        setFilter[1] = this.selectedOperator ? this.selectedOperator : "=";
        setFilter[2] = e.value;
        filter.push(setFilter);
        if (this.numberBoxOptions[0].negativePositive) {
          filter = this.getNegativeFilter(filter, setFilter);
        }
      } else {
        if (
          (this.fromValue && !this.toValue) ||
          (!this.fromValue && this.toValue)
        ) {
          setFilter = [];
          setFilter[0] = this.numberBoxOptions[0].dataField;
          setFilter[1] = !this.toValue ? ">=" : !this.fromValue ? "<=" : "=";
          setFilter[2] = this.fromValue
            ? this.fromValue
            : this.toValue
            ? this.toValue
            : null;
          filter.push(setFilter);
          if (this.numberBoxOptions[0].negativePositive) {
            filter = this.getNegativeFilter(filter, setFilter);
          }
        } else if (this.fromValue && this.toValue) {
          let negtive = [];
          setFilter = [];
          setFilter[0] = this.numberBoxOptions[0].dataField;
          setFilter[1] = ">=";
          setFilter[2] = this.fromValue;

          if (this.numberBoxOptions[0].negativePositive) {
            negtive = this.getNegativeFilter(negtive, setFilter);
          }
          filter.push(setFilter);
          filter.push("and");
          setFilter = [];
          setFilter[0] = this.numberBoxOptions[0].dataField;
          setFilter[1] = "<=";
          setFilter[2] = this.toValue;
          filter.push(setFilter);

          if (this.numberBoxOptions[0].negativePositive) {
            negtive.push("and");
            negtive.push(this.getNegativeFilter([], setFilter));
          }
          if (negtive.length > 0) {
            filter = [filter];
            filter.push("or");
            filter.push(negtive);
          }
        }
      }

      if (this.numberBoxOptions[0].formLocation == "form-report") {
        this.valueChangeCallBack(this.dataField, e.value);
      } else if (this.numberBoxOptions[0].formLocation == "data-grid") return;
      else {
        this.valueChangeCallBack(this.dataField, filter);
      }
    },
    initialized(e) {
      if (this.defaultValue) {
        var defaultValue = undefined;
        if (Array.isArray(this.defaultValue)) {
          defaultValue = this.defaultValue[0];
        } else if (
          Object.keys(this.numberBoxOptions[0].defaultValue).length > 0
        ) {
          defaultValue = this.numberBoxOptions[0].defaultValue.from;
        } else defaultValue = this.defaultValue;
        e.component.beginUpdate();
        e.component.option("value", defaultValue);
        e.component.endUpdate();

        this.fromValue = defaultValue;

        if (defaultValue) this.onNumberValueChanged({ value: defaultValue });
      }
    },
    getNegativeFilter(filter, setFilter) {
      if (filter.length > 0) filter.push("or");
      filter.push([setFilter[0], setFilter[1], -Math.abs(setFilter[2])]);

      return filter;
    },
  },
  computed: {
    fromDatasource() {
      return this.numberBoxOptions[0].dataSourceConfig.endpoint
        ? GridReportService.dataSourceConfig(
            this.numberBoxOptions[0].dataSourceConfig.endpoint,
            {
              select: this.numberBoxOptions[0].dataSourceConfig.select
                ? this.numberBoxOptions[0].dataSourceConfig.select
                : [
                    this.numberBoxOptions[0].valueExpr,
                    this.numberBoxOptions[0].displayExpr,
                  ],
              sort: this.numberBoxOptions[0].dataSourceConfig.sort
                ? this.numberBoxOptions[0].dataSourceConfig.sort
                : undefined,
              filter: this.setFromFilter,
            }
          )
        : undefined;
    },
    toDatasource() {
      return this.numberBoxOptions[0].dataSourceConfig.endpoint
        ? GridReportService.dataSourceConfig(
            this.numberBoxOptions[0].dataSourceConfig.endpoint,
            {
              select: this.numberBoxOptions[0].dataSourceConfig.select
                ? this.numberBoxOptions[0].dataSourceConfig.select
                : [
                    this.numberBoxOptions[0].valueExpr,
                    this.numberBoxOptions[0].displayExpr,
                  ],
              sort: this.numberBoxOptions[0].dataSourceConfig.sort
                ? this.numberBoxOptions[0].dataSourceConfig.sort
                : undefined,
              filter: this.setToFilter,
              // postProcess: this.toSelectPostProcess,
            }
          )
        : undefined;
    },
    setFromFilter() {
      var filter = this.numberBoxOptions[0].dataSourceConfig.filter
        ? this.numberBoxOptions[0].dataSourceConfig.filter
        : undefined;

      if (this.toValue) {
        if (!filter) filter = [];
        if (filter.length == 0) {
          filter.push([this.valueExpr, "<", this.toValue]);
        }
      }
      return filter;
    },
    setToFilter() {
      var filter = this.numberBoxOptions[0].dataSourceConfig.filter
        ? this.numberBoxOptions[0].dataSourceConfig.filter
        : undefined;

      if (this.fromValue) {
        if (!filter) filter = [];
        if (filter.length == 0) {
          filter.push([this.valueExpr, ">", this.fromValue]);
        }
      }
      return filter;
    },
    toFromItems() {
      var items = this.numberBoxOptions[0].dataSourceConfig.data
        ? this.numberBoxOptions[0].dataSourceConfig.data
        : undefined;

      if (items) {
        if (this.toValue) {
          return items.filter((x) => {
            return x[this.valueExpr] < this.toValue;
          });
        } else return items;
      } else return [];
    },
    toDataItems() {
      var items = this.numberBoxOptions[0].dataSourceConfig.data
        ? this.numberBoxOptions[0].dataSourceConfig.data
        : undefined;

      if (items) {
        if (this.fromValue) {
          return items.filter((x) => {
            return x[this.valueExpr] > this.fromValue;
          });
        } else return items;
      } else return [];
    },
    selectFromClearBtn() {
      return {
        icon: "clear",
        type: "clear",
        template: "select-from-clear",
        elementAttr: { class: "select-from-clear dx-clear-button-area" },
        visible: true,
      };
    },
  },
};
</script>

<style lang="scss">
.custom-auto-complete {
  .auto-complete-secondary {
    padding-left: 5px;
    font-size: 10px;
    color: gray;
  }

  .no-padding {
    padding-left: 0 !important;
  }
}

.select-box-group {
  width: 100%;

  .select-to {
    display: inline-flex;

    //   padding-top: 35px;
    span {
      vertical-align: middle;
      align-self: center;
      padding-right: 10px;
      padding-left: 5px;
    }
  }

  .select-from-clear {
    opacity: 1 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    width: 25px !important;
    min-width: 25px;

    .dx-icon-clear {
      color: rgba(117, 117, 117, 0.87);
      background-color: rgba(194, 194, 194, 0.87);
      border-radius: 50%;
      position: absolute;
      top: 50%;
      margin-top: -11px !important;
      width: 22px;
      height: 22px;
      background-position: 0 0;
      background-size: 12px 12px;
      padding: 0;
      font-size: 12px;
      text-align: center;
      line-height: 12px;
    }

    .dx-icon-clear::before {
      position: absolute;
      display: block;
      width: 12px;
      height: 12px;
      top: 50%;
      margin-top: -6px;
      left: 50%;
      margin-left: -6px;
    }

    .dx-inkripple .dx-inkripple-wave {
      width: 22px !important;
      height: 22px !important;
      opacity: 1 !important;
      top: 3px !important;
      left: 2px !important;
    }
  }

  .select-from-clear:hover,
  .select-from-clear:focus {
    background-color: unset;
  }

  .select-from-clear.dx-state-active {
    background-color: unset;
  }

  .select-from .dx-texteditor-input-container input.dx-texteditor-input {
    padding-right: 0 !important;
  }

  .select-to .dx-texteditor-input-container input.dx-texteditor-input {
    text-overflow: unset;
  }

  .select-from-clear {
    opacity: 1 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    width: 25px !important;
    min-width: 25px;
  }

  .search-option {
    .dx-button-content {
      padding: 0 !important;

      .dx-icon {
        margin: 0 !important;
      }
    }

    padding: 0 !important;
  }

  .dx-dropdownbutton {
    height: auto;
  }
}

.select-box-group.select-box-multi-line {
  flex-direction: column;

  .select-to {
    padding-top: 10px;
    justify-content: space-between;

    .dx-selectbox {
      width: 100%;

      .dx-texteditor-input-container {
        > input,
        .dx-placeholder::before {
          padding-left: 6px;
        }
      }

      .dx-clear-button-area {
        padding-left: unset !important;
      }
    }
  }
}
</style>
